module.exports = __webpack_public_path__ + "static/media/3.4fce98db.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/3.JPG
// module id = 473
// module chunks = 0